import { useTranslation } from 'react-i18next'
import Style from './index.module.less'
import { formatTime } from '@/views/Home/utils'
import useMeNavigate from '@/hooks/useMeNavigate'
import { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import { useGlobalStore } from '@/hoxStore/globalStore'
import { ValidatorNodeFormat } from '@/enums'

const LatestBlockCard = ({ cardData = null, index }: { cardData: any; index: number }) => {
  const { t } = useTranslation()
  const navigate = useMeNavigate()
  const { curReponsive } = useGlobalStore()
  const timeId = useRef<NodeJS.Timeout>()
  const formatTimeAgo = (timeAgo: string) => {
    if (!timeAgo) return '-'
    return timeAgo
      .replace('&_d', t('explorer_225'))
      .replace('&_h', t('explorer_224'))
      .replace('&_m', t('explorer_223'))
      .replace('&_s', t('explorer_21'))
  }

  const [time, setTime] = useState(formatTimeAgo(formatTime(cardData.timestamp) || ''))

  useEffect(() => {
    timeId.current = setInterval(() => {
      setTime(formatTimeAgo(formatTime(cardData.timestamp) || ''))
    }, 1000)
    return () => {
      clearTimeout(timeId.current)
    }
  }, [cardData.timestamp])

  if (!cardData) return null
  const formatNode = (val: string) => {
    if (!val) return '-'
    const newVal = val.replace('-node', '').trim()
    if (ValidatorNodeFormat[newVal.toLocaleUpperCase() as keyof typeof ValidatorNodeFormat]) {
      return t(ValidatorNodeFormat[newVal.toLocaleUpperCase() as keyof typeof ValidatorNodeFormat])
    }
    return newVal
  }
  return (
    <div className={'home_new_block_item_wrap'} data-index={index}>
      <div className={'home_new_block_item'}>
        <div className={Style.wrapItem}>
          <div
            className={classNames({
              [Style.title]: true,
              font_14: true,
              font_12: curReponsive?.size == 'mobile',
            })}
          >
            <span style={{ marginRight: '4px' }}> {time}</span>
            {t('explorer_22')}
          </div>
          {/* 区块高度的数值 */}
          <div
            className={classNames({
              [Style.timeNum]: true,
              font_14: true,
              [Style.lineHeight]: true,
            })}
            onClick={() => {
              navigate(`/blockchain/${cardData.height}`)
            }}
          >
            {cardData.height}
          </div>
        </div>
        <div className={Style.wrapItem}>
          {/*交易数*/}
          <div
            className={classNames({
              [Style.title]: true,
              font_14: true,
              font_12: curReponsive?.size == 'mobile',
            })}
          >
            {t('explorer_101')}
          </div>
          <div
            className={classNames({
              [Style.transactionsNum]: true,
              font_14: true,
              font_12: curReponsive?.size == 'mobile',
            })}
          >
            {cardData.num_txs} TX
          </div>
        </div>
        {/* <div className={Style.wrapItem}>
          出块节点
          <div
            className={classNames({
              [Style.title]: true,
              font_14: true,
              font_12: curReponsive?.size == 'mobile',
            })}
          >
            {t('explorer_20')}
          </div>
          <div
            className={classNames({
              [Style.FastNode]: true,
              font_14: true,
              [Style.lineHeight]: true,
            })}
          >
            {formatNode(cardData?.validator_description.moniker) || '--'}
          </div>
        </div> */}
      </div>
    </div>
  )
}

export default LatestBlockCard
